import "./Companies.scss";
import { BusinessIcon, SearchIcon, MapPinIcon, UserIcon, ExternalLinkIcon, AddIcon } from "../../../../../shared/cockpit/components/icons/Icon";

interface Company {
  id: string;
  name: string;
  role: "HOLDING" | "BESITZ" | "BETRIEB";
  headquarters: string;
  contact: string;
}

const companiesData: Company[] = [
  {
    id: "C1",
    name: "Schmidt Holding GmbH",
    role: "HOLDING",
    headquarters: "Hauptstr. 1, 10115 Berlin",
    contact: "M. Schmidt",
  },
  {
    id: "C2",
    name: "FitX Immobilien GmbH",
    role: "BESITZ",
    headquarters: "Fitnessweg 2, 80331 München",
    contact: "K. Müller",
  },
  {
    id: "C3",
    name: "Spielstation Betriebs GmbH",
    role: "BETRIEB",
    headquarters: "Spielallee 4, 20095 Hamburg",
    contact: "L. Weber",
  },
  {
    id: "C4",
    name: "CaOs Wohnen GmbH",
    role: "BESITZ",
    headquarters: "Wohnring 10, 50667 Köln",
    contact: "S. Meyer",
  },
];

function Companies() {
  return (
    <div className="companies-view">
      <header className="companies-view__header">
        <div className="companies-view__header__content">
          <div className="companies-view__header__title--container">
            <div className="companies-view__header__icon-wrapper">
              <BusinessIcon />
            </div>
            <h2 className="companies-view__header__title">Gesellschaften</h2>
          </div>

          <p className="companies-view__header__subtitle">
            Verwaltung aller Besitz-, Betriebs- und Holdinggesellschaften der
            Schmidt Gruppe.
          </p>
        </div>
        <button className="companies-view__header__add-btn">
          <AddIcon /> Neue Gesellschaft
        </button>
      </header>

      <div className="companies-view__content">
        <div className="companies-view__search-bar">
          <SearchIcon className="companies-view__search-icon" />
          <input type="text" placeholder="Gesellschaft suchen..." />
        </div>

        <div className="companies-table">
          <div className="companies-table__header">
            <div className="companies-table__col">GESELLSCHAFT</div>
            <div className="companies-table__col">ROLLE</div>
            <div className="companies-table__col">HAUPTSITZ</div>
            <div className="companies-table__col">ANSPRECHPARTNER</div>
            <div className="companies-table__col text-right">AKTION</div>
          </div>

          <div className="companies-table__body">
            {companiesData.map((company) => (
              <div key={company.id} className="companies-table__row">
                <div className="companies-table__col">
                  <div className="company-info">
                    <span className="company-info__name">{company.name}</span>
                    <span className="company-info__id">ID: {company.id}</span>
                  </div>
                </div>
                <div className="companies-table__col">
                  <span
                    className={`role-badge role-badge--${company.role.toLowerCase()}`}
                  >
                    {company.role}
                  </span>
                </div>
                <div className="companies-table__col">
                  <div className="location-info">
                    <MapPinIcon className="location-info__icon" />
                    <span>{company.headquarters}</span>
                  </div>
                </div>
                <div className="companies-table__col">
                  <div className="contact-info">
                    <UserIcon className="contact-info__icon" />
                    <span>{company.contact}</span>
                  </div>
                </div>
                <div className="companies-table__col text-right">
                  <button className="action-btn">
                    <ExternalLinkIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Companies;
